import { EMPTY_LIST } from '../../constants/common'
import { LISTING_DETAILS_SNAPSHOT } from '../../utils/rentalPortalMockData'
import { toRentalPortalMockMediaPhoto } from '../../utils/rentalPortalMockMedia'

function toMockListingPhoto(photo) {
  return { ...toRentalPortalMockMediaPhoto(photo), mime_type: 'image/jpeg' }
}

const MOCK_LISTING_PHOTOS_SNAPSHOT_BY_ID = new Map(
  LISTING_DETAILS_SNAPSHOT.map(detail => [
    detail.id,
    (detail.photos ?? EMPTY_LIST).map(toMockListingPhoto),
  ])
)

const MOCK_LISTING_PHOTOS_BY_ID = new Map()

function getMockListingPhotosSource(listingId) {
  if (!MOCK_LISTING_PHOTOS_BY_ID.has(listingId)) {
    MOCK_LISTING_PHOTOS_BY_ID.set(listingId, [
      ...(MOCK_LISTING_PHOTOS_SNAPSHOT_BY_ID.get(listingId) ?? EMPTY_LIST),
    ])
  }

  return MOCK_LISTING_PHOTOS_BY_ID.get(listingId)
}

function getMockListingPhotos(listingId) {
  return listingId ? [...getMockListingPhotosSource(listingId)] : EMPTY_LIST
}

export function getMockListingPhotoCount(listingId) {
  return getMockListingPhotos(listingId).length
}
